<script>
export default {
  components: {},
  created() {
    document.body.classList.add('authentication-v2');
  },
  beforeDestroy() {
    document.body.classList.remove('authentication-v2');
  },
}
</script>

<template>
  <div class="auth-layout-root tw-min-h-screen tw-bg-light-bg">
    <slot/>
  </div>
</template>

<style lang="scss">
@import '@design';

body.authentication-v2 {
  background: $color_light_bg;
}
</style>
